import themeNames from "../themeNames";
import * as palette from "../palette/upgrade";
import * as typography from "../typography/upgrade";
import * as borderRadius from "../constants/border-radius";

/** Note: please do add any colors to this file, colors should be defined in palette/*   */
export default {
  name: themeNames.UPGRADE_THEME_NAME,
  palette: palette,
  typography: typography,
  brandName: "Upgrade",
  minLoanAmount: 1000,
  // @deprecated - use defaultMinLoanAmount instead
  maxLoanAmount: 50000,
  // @deprecated - use defaultMaxLoanAmount instead
  defaultMinLoanAmount: 1000,
  defaultMaxLoanAmount: 50000,
  defaultMetaUrl: "https://www.upgrade.com",
  defaultMetaTitle: "Personal Loans and Cards",
  defaultMetaDescription: "Check your rate for a low fixed-rate personal loan in just minutes. Borrow up to $50,000 with no prepayment penalties. Checking your rate has no impact to your credit score.",
  defaultMetaImage: "https://www.upgrade.com/img/hero-lake.jpg",
  borrowerDashboardLoginMetaTitle: "Sign in",
  borrowerDashboardLoginMetaDescription: "Sign in to securely access your Upgrade account. Personal loans, Upgrade Card, Rewards Checking, and Credit Health.",
  publicSiteLendingPartnersPagePath: "/bank-partners",
  borrowerDashboardLoginPageProductCardLinks: [{
    title: "Upgrade Card",
    description: "Affordable credit line",
    link: "/funnel/pcl/pi1?utm_source=deactivated"
  }, {
    title: "Personal Loans",
    description: "Borrow up to $50,000",
    link: "/funnel/personal-information-1?step=contact&utm_source=deactivated"
  }, {
    title: "Rewards Checking",
    description: "No fee checking with cash back*",
    link: "/deposit/enroll?utm_source=deactivated"
  }, {
    title: "Auto Refinance",
    description: "Lower your monthly car payment",
    link: "/auto-refi/?utm_source=deactivated"
  }],
  borrowerDashboardLoginPageProductDisclaimers: ["* Rewards Checking customers earn 2% cash back on common everyday expenses at convenience stores, drugstores, restaurants and bars - including deliveries - and gas stations, as well as recurring payments on utilities and monthly subscriptions including phone, cable, TV and other streaming services, and 1% cash back on all other debit card charges. 2% cash back is limited to $500 in rewards per calendar year; after $500, customers earn 1% cash back on all eligible debit card charges for the remainder of the year. Some limitations apply. Please refer to the applicable Upgrade VISA® Debit Card Agreement and Disclosures for more information."],
  betterBusinessBureauBadge: {
    link: "http://www.bbb.org/greater-san-francisco/business-reviews/loans/upgrade-inc-in-san-francisco-ca-876655/#sealclick",
    imageSrc: "https://seal-goldengate.bbb.org/seals/black-seal-280-80-bbb-876655.png",
    alt: "Upgrade, Inc. BBB Business Review"
  },
  trustedSite: {
    link: "https://www.trustedsite.com/verify?host=upgrade.com",
    imageSrc: "https://cdn.ywxi.net/meter/upgrade.com/202.svg"
  },
  footerBankNoticePersonalLoanText: "All loans are made by Upgrade's ",
  footerBankNoticePersonalLoanWithAutoRefinanceText: "All loans are made by Upgrade's ",
  /*
   * Z-index
   */
  zIndex: {
    spinner: 10000,
    tooltip: 9000,
    notification: 8000,
    modal: 7000,
    dropdown: 6000,
    header: 5000,
    subNavigation: 4900,
    stickyActions: 4800
  },
  /*
   * Base
   */
  linkHoverDecoration: "underline",
  linkDecoration: "underline",
  tableCellPadding: "0.75rem",
  /*
   * Typography
   */
  fontFamilyBase: '"Graphik", Arial, sans-serif',
  fontSizeBase: "16px",
  fontWeightBase: "normal",
  lineHeightBase: "1.5rem",
  headingsFontFamily: '"Graphik", Arial, sans-serif',
  headingsMarginBottom: "1rem",
  dtFontWeight: "bold",
  numbersFontFamily: '"Roboto", Arial, sans-serif',
  iconFontFamily: "upgrade-icons",
  /*
   * Layout
   */
  layoutMaxWidth: "80rem",
  /*
   * Media breakpoints
   */
  mediaXs: "30em",
  mediaXsPx: "480px",
  mediaXsMinusOnePx: "479px",
  mediaSm: "48em",
  mediaSmHeader: "59em",
  mediaSmPx: "768px",
  mediaSmMinusOnePx: "767px",
  mediaMd: "64em",
  mediaMdPx: "1024px",
  mediaMdMinusOnePx: "1023px",
  mediaLg: "75em",
  mediaLgPx: "1200px",
  mediaLgMinusOnePx: "1199px",
  spacing: {
    none: "0",
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    "2xl": "3rem",
    "3xl": "4rem",
    "4xl": "6rem",
    "5xl": "8rem",
    "6xl": "16rem"
  },
  /*
   * Containers
   */
  containerBorderRadius: borderRadius.DEFAULT,
  /*
   * Surfaces
   */
  surfaceBorderRadius: borderRadius.DEFAULT,
  // Base variables
  btnBorderRadius: borderRadius.DEFAULT,
  btnFontSize: "1rem",
  btnLineHeight: "1.5rem",
  btnPadding: "calc(1rem - 2px) 2rem",
  btnFontWeight: "500",
  btnBorder: "2px solid transparent",
  // Sizes
  btnLargeFontSize: "1.25rem",
  btnLargeLineHeight: "1.5rem",
  btnLargePadding: "calc(1.5rem - 2px) 2.25rem",
  btnSmallFontSize: "0.875rem",
  btnSmallLineHeight: "1.5rem",
  btnSmallPadding: "calc(0.5rem - 2px) 1rem",
  btnXSmallFontSize: "0.6875rem",
  btnXSmallLineHeight: "1rem",
  btnXSmallPadding: "calc(0.25rem - 2px) 1rem",
  /*
   * Text Inputs
   */
  textInputFontSize: "1rem",
  textInputFontSizeSmall: "0.875rem",
  textInputFontSizeLarge: "1.2rem",
  textInputHeight: "calc(3.5rem - 2px)",
  // IE 11 and under need an explicit height
  textInputHeightSmall: "calc(2.5rem - 2px)",
  // IE 11 and under need an explicit height
  textInputHeightLarge: "calc(4.5rem - 2px)",
  // IE 11 and under need an explicit height
  textInputPadding: "0.875rem 1rem",
  textInputPaddingSmall: "0.5rem 1rem",
  textInputPaddingFloating: "1.25rem 1rem .5rem",
  textInputPaddingFloatingSmall: "1.25rem 1rem .5rem",
  textInputPaddingFloatingLarge: "1.5rem 1rem .5rem",
  textInputPaddingLarge: "0.875rem 1rem",
  textInputTop: "50%",
  textInputTopFloating: "0.875rem",
  textInputWeight: "500",
  textInputWeightSmall: "500",
  textInputWeightLarge: "500",
  textInputBorder: "1px solid ".concat(palette.borderStrong),
  textInputBorderRadius: borderRadius.SMALL,
  // Focus
  textInputFocusBorder: "1px solid ".concat(palette.semanticInfoStrong),
  textInputFocusShadow: "".concat(palette.semanticInfoStrong, " 0 0 0 1px"),
  // Placeholder Label
  textInputLabelFontSize: "1rem",
  textInputLabelSmallFontSize: "0.875rem",
  textInputLabelLargeFontSize: "1.2rem",
  // Placeholder Label Floating State
  textInputLabelFloatingFontSize: ".75rem",
  textInputLabelFloatingLargeFontSize: ".75rem",
  textInputLabelFloatingFontWeight: "400",
  textInputLabelFloatingLargeFontWeight: "500",
  // Error State
  textInputErrorBorder: "1px solid ".concat(palette.semanticError),
  // Form group (input + label + messages) margin
  formGroupMargin: "0 0 0.5rem 0",
  // Text area
  textAreaFontSize: "1rem",
  textAreaPadding: "1rem 1.5rem",
  textAreaBorder: "1px solid ".concat(palette.borderStrong),
  textAreaBorderRadius: borderRadius.SMALL,
  // Modals
  modalOverlayBackground: palette.backgroundOverlay,
  modalBorder: "1px solid ".concat(palette.border),
  modalBorderRadius: borderRadius.DEFAULT,
  modalPadding: "1.5rem",
  modalPaddingSm: "1.5rem",
  modalSizeAuto: "75%",
  modalSizeSmall: "30em",
  modalSizeMedium: "40em",
  modalSizeLarge: "50em",
  modalSizeFull: "100%",
  // tables
  tableCellPaddingLarge: "1rem",
  tableBorderBottom: "1px solid ".concat(palette.border),
  /* box shadow */
  boxShadowHighest: "0px 10px 38px ".concat(palette.shadowHighest),
  boxShadowHigh: "0px 7px 20px ".concat(palette.shadowHigh),
  boxShadowMedium: "0px 4px 10px ".concat(palette.shadowMedium),
  boxShadowLow: "0px 2px 5px ".concat(palette.shadowLow),
  boxShadowMediumUpward: "0px -5px 7px ".concat(palette.shadowMediumUpward),
  /* border radiuses */
  extraSmallBorderRadius: borderRadius.EXTRA_SMALL,
  smallBorderRadius: borderRadius.SMALL,
  defaultBorderRadius: borderRadius.DEFAULT,
  /* Focus Indicator */
  focusColor: palette.accentSecondary1,
  focusColorReverse: palette.semanticInfoStrongReverse,
  focusWidth: "3px",
  focusOffset: "3px",
  focusRadius: "3px",
  focusBoxShadow: "".concat(palette.accentSecondary1, " 0 0 0 3px"),
  focusBoxShadowReverse: "".concat(palette.semanticInfoStrongReverse, " 0 0 0 3px")
};
//# sourceMappingURL=upgrade.js.map